import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }

import { onMounted, ref, watch } from "vue";
import { pushEvent } from "@/services/dataLayerLogin";
import GlobalError from "@/components/GlobalError.vue";
import SharedButton from "@SharedVueComponents/SharedButton.vue";
import SharedForm from "@SharedVueComponents/SharedForm/SharedForm.vue";
import SharedTextfield from "@SharedVueComponents/SharedNewTextfield.vue";
import { store } from "@/state/store";
import { authenticate } from "@/services/ocmAuthentication";
import BasicSkeleton from "@SharedVueComponents/BasicSkeleton/BasicSkeleton.vue";
import { $t } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props, { expose: __expose }) {

let section: "login" | "registration" = "login";
const email = ref("");
const isSubmitLoading = ref(false);

const loginForm = ref<InstanceType<typeof SharedForm> | null>(null);
const loginFormIsVisible = ref(false);

watch(
	() => store.isLogin,
	() => {
		section = store.isLogin ? "login" : "registration";
		resetForm();
	}
);

onMounted(() => {
	section = store.isLogin ? "login" : "registration";
	if (store.isLandingPage) loginFormIsVisible.value = true;
});

function handleOnSubmit(fieldName: string, errorMessage: string | undefined) {
	errorMessage && pushEvent(`submit_${fieldName}_error`, errorMessage);
}

function handleOnInput() {
	resetGlobalError();
}

function resetForm() {
	resetValidation();
	resetGlobalError();
}

function resetValidation() {
	if (loginForm.value) {
		loginForm.value.resetFormValidation();
	}
}

function resetGlobalError() {
	store.globalErrorMessages = [];
	store.httpErrorStatusCode = null;
}

function clearFormData() {
	resetForm();
	email.value = "";
}

function requestFirstLogin() {
	// TUB-18186 show sceleton instead of form the first time modal is opened
	// reason: prevent autofill freeze in Chrome-Browsers
	// timeout Value as defined in _popup.scss .animated
	window.setTimeout(() => {
		loginFormIsVisible.value = true;
	}, 400);
}

function handleOnChange(fieldName: string, errorMessage: string | undefined) {
	errorMessage && pushEvent(`change_${fieldName}_error`, errorMessage);
}

async function handleSubmitClick() {
	isSubmitLoading.value = true;
	await submitForm();
}

async function submitForm() {
	const authData: { j_username?: string } = {};
	if (email.value) authData["j_username"] = email.value;

	const success = await authenticate(authData, section);
	if (!success) isSubmitLoading.value = false;
}

function ocmButtonClick() {
	pushEvent("OCMButton");
}

__expose({
	clearFormData,
	requestFirstLogin,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loginFormIsVisible.value)
      ? (_openBlock(), _createBlock(SharedForm, {
          key: 0,
          ref_key: "loginForm",
          ref: loginForm,
          "show-error": false,
          "error-message": "",
          "no-submit-button-gap": true,
          onSubmit: _withModifiers(handleSubmitClick, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(SharedTextfield, {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              "pattern-error-message": _unref($t)('validation.email'),
              name: "j_username",
              "display-name": _unref($t)('email-display-name'),
              type: "email",
              autocomplete: "username",
              label: _unref($t)(_unref(store).isLogin ? 'login.email_input_placeholder' : 'registration.email_input_placeholder'),
              class: "mb-4",
              "forced-error-message": _unref(store).httpErrorStatusCode === 422 ? ' ' : undefined,
              maxlength: "126",
              "validate-on-change": "",
              onInput: handleOnInput,
              onChange: _cache[1] || (_cache[1] = (_, data) => handleOnChange('email', data.errorMessage)),
              onFormSubmit: _cache[2] || (_cache[2] = (_, data) => handleOnSubmit('email', data.errorMessage))
            }, null, 8, ["modelValue", "pattern-error-message", "display-name", "label", "forced-error-message"]),
            _createVNode(GlobalError, { class: "mt-2" }),
            _createVNode(SharedButton, {
              type: "submit",
              class: "mt-2 w-full",
              "is-loading": isSubmitLoading.value,
              onClick: ocmButtonClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)(_unref(store).isLogin ? "login.submit_button" : "registration.submit_button")), 1)
              ]),
              _: 1
            }, 8, ["is-loading"])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(BasicSkeleton, { class: "mb-4 h-15" }),
      _createVNode(BasicSkeleton, { class: "mt-2 h-11.5" })
    ], 512), [
      [_vShow, !loginFormIsVisible.value]
    ])
  ]))
}
}

})